import "./Privacy.scss";
import AnimatedLink from "../../UI/AnimatedLink/AnimatedLink";

const Privacy = () => {
  return (
    <section className="privacy" id="privacy">
      <div className="container">
        <div className="privacy__wrapper">
          <h1 className="privacy__title">Политика конфиденциальности</h1>

          <p className="privacy__text">
            Настоящая Политика конфиденциальности персональных данных (далее –
            Политика) действует в отношении всей информации, которую сайт{" "}
            <AnimatedLink text="https://artcode-dev.vercel.app/" href="https://artcode-dev.vercel.app/" />
            , (далее – Сайт) расположенный на доменном имени vercel.app, может
            получить о Пользователе во время использования сайта.
          </p>

          <h2 className="privacy__subtitle">1. Определение терминов</h2>
          <p className="privacy__text">
            1.1. Персональные данные - любая информация, относящаяся к прямо или
            косвенно определенному, или определяемому физическому лицу (субъекту
            персональных данных).
          </p>
          <p className="privacy__text">
            1.2. Обработка персональных данных - любое действие (операция) или
            совокупность действий (операций), совершаемых с использованием
            средств автоматизации или без использования таких средств с
            персональными данными, включая сбор, запись, систематизацию,
            накопление, хранение, уточнение (обновление, изменение), извлечение,
            использование, передачу (распространение, предоставление, доступ),
            обезличивание, блокирование, удаление, уничтожение персональных
            данных.
          </p>
          <p className="privacy__text">
            1.3. Конфиденциальность персональных данных - обязательное для
            соблюдения Оператором или иным получившим доступ к персональным
            данным лицом требование не допускать их распространения без согласия
            субъекта персональных данных или наличия иного законного основания.
          </p>

          <h2 className="privacy__subtitle">2. Основные правила</h2>
          <p className="privacy__text">
            2.1. Использование Пользователем Сайта означает согласие с настоящей
            Политикой конфиденциальности и условиями обработки персональных
            данных Пользователя.
          </p>
          <p className="privacy__text">
            2.2. В случае несогласия с условиями Политики конфиденциальности
            Пользователь должен прекратить использование Сайта.
          </p>
          <p className="privacy__text">
            2.3. Настоящая Политика конфиденциальности применяется только к
            сайту{" "}

            <AnimatedLink text="https://artcode-dev.vercel.app/" href="https://artcode-dev.vercel.app/" />
            . Сайт не контролирует и не несет ответственность за сайты третьих
            лиц, на которые Пользователь может перейти по ссылкам, доступным на
            Сайте.
          </p>

          <h2 className="privacy__subtitle">
            3. Какую информацию мы собираем?
          </h2>
          <p className="privacy__text">
            Сайт может собирать следующую информацию о Пользователе:
          </p>
          <p className="privacy__text">
            3.1. Информация, предоставляемая пользователем: Фамилия, имя,
            отчество, номер телефона, адрес электронной почты, а также иные
            данные, добровольно предоставленные Пользователем при заполнении
            форм обратной связи, регистрации, подписки на рассылку или
            совершении иных действий на Сайте.
          </p>
          <p className="privacy__text">
            3.2. Данные, собираемые автоматически: Информация о браузере и
            устройстве (тип, версия, разрешение экрана), технические
            характеристики устройства и программного обеспечения, IP-адрес,
            данные cookie, сведения о местоположении, провайдер, а также данные
            о посещенных страницах, времени spent на Сайте и другие стандартные
            данные веб-аналитики (Google Analytics, Яндекс.Метрика и аналоги).
          </p>

          <h2 className="privacy__subtitle">
            4. Цели сбора и обработки персональных данных
          </h2>
          <p className="privacy__text">
            4.1. Сайт собирает и хранит только те персональные данные, которые
            необходимы для:
          </p>
          <ul className="privacy__list">
            <li className="privacy__item">
              Обратной связи с Пользователем по его запросу.
            </li>
            <li className="privacy__item">
              Предоставления Пользователю информации об услугах и акциях.
            </li>
            <li className="privacy__item">
              Заключения и исполнения договоров с клиентами.
            </li>
            <li className="privacy__item">
              Улучшения качества Сайта и удобства его использования.
            </li>
            <li className="privacy__item">
              Проведения статистических и иных исследований на основе
              обезличенных данных.
            </li>
          </ul>

          <h2 className="privacy__subtitle">
            5. Условия обработки персональных данных
          </h2>
          <ul className="privacy__list">
            <li className="privacy__item">
              5.1. Обработка персональных данных Пользователя осуществляется без
              ограничения срока, любым законным способом.
            </li>
            <li className="privacy__item">
              5.2. Сайт принимает необходимые организационные и технические меры
              для защиты персональной информации Пользователя от неправомерного
              или случайного доступа, уничтожения, изменения, блокирования,
              копирования, распространения, а также от иных неправомерных
              действий третьих лиц.
            </li>
            <li className="privacy__item">
              5.3. Предоставляя свои персональные данные, Пользователь
              соглашается на их обработку (включая передачу третьим лицам,
              необходимым для выполнения целей, указанных в п. 4 настоящей
              Политики) администрацией Сайта.
            </li>
          </ul>

          <h2 className="privacy__subtitle">6. Передача персональных данных</h2>
          <ul className="privacy__list">
            <li className="privacy__item">
              6.1. Персональные данные Пользователя могут быть переданы
              уполномоченным органам государственной власти Российской Федерации
              только по основаниям и в порядке, установленным законодательством
              РФ.
            </li>
            <li className="privacy__item">
              6.2. Сайт не продает и не передает персональные данные третьим
              лицам для целей, не указанных в настоящей Политике, без прямого
              согласия Пользователя.
            </li>
          </ul>

          <h2 className="privacy__subtitle">
            7. Изменение персональных данных
          </h2>
          <p className="privacy__text">
            7.1. Пользователь может в любой момент изменить (обновить,
            дополнить) предоставленные им персональные данные, направив
            соответствующий запрос по контактным данным, указанным на Сайте.
          </p>

          <h2 className="privacy__subtitle">
            8. Отзыв согласия на обработку данных
          </h2>
          <p className="privacy__text">
            8.1. Пользователь вправе в любой момент отозвать свое согласие на
            обработку персональных данных, направив соответствующий запрос по
            электронной почте или телефону, указанным в контактах на Сайте.
            После получения такого запроса обработка персональных данных
            Пользователя будет прекращена, а его персональные данные удалены, за
            исключением случаев, когда обработка может быть продолжена в
            соответствии с законодательством.
          </p>

          <h2 className="privacy__subtitle">9. Использование файлов cookie</h2>
          <p className="privacy__text">
            9.1. Сайт использует файлы cookie для персонализации контента,
            анализа трафика и улучшения функциональности. Пользователь может
            отключить использование файлов cookie в настройках своего браузера.
            Обратите внимание, что это может повлиять на работоспособность
            некоторых функций Сайта.
          </p>

          <h2 className="privacy__subtitle">10. Заключительные положения</h2>
          <ul className="privacy__list">
            <li className="privacy__item">
              10.1. Администрация Сайта вправе вносить изменения в настоящую
              Политику конфиденциальности. Новая редакция Политики вступает в
              силу с момента ее размещения на Сайте, если иное не предусмотрено
              новой редакцией Политики.
            </li>
            <li className="privacy__item">
              10.2. Все предложения или вопросы по настоящей Политике
              конфиденциальности следует сообщать по контактным данным,
              указанным в соответствующем разделе Сайте.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};


export default Privacy;